import gql from 'graphql-tag';

import { PagesFragmentDoc } from '../../generated/graphql';

export const pageQuery = gql`
  query pageQuery($id: Int!) {
    page(id: $id) {
      ...Pages
    }
  }
  ${PagesFragmentDoc}
`;
